module.exports = __webpack_public_path__ + "img/Middle_Exhibition_Logo.79c668f8.jpg";